// Wrapper sobre a lib qrcode (npm) — gera data URL PNG do QR.
// Usado no PrintableHeader para apontar pra URL da NC no app.
import QRCode from 'qrcode';

export async function generateQRCode(text) {
  try {
    return await QRCode.toDataURL(text, {
      width: 160,
      margin: 1,
      color: {
        dark: '#111827',
        light: '#FFFFFF',
      },
    });
  } catch (err) {
    console.error('Erro ao gerar QR:', err);
    return '';
  }
}
